module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1h_U.d760b7f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1h_U.svg
// module id = 516
// module chunks = 0